import React from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '../api';
import './smart.css';

// Erkin matnli qidiruv: «2 ta yigit talabaga Chilonzorda 5 mln gacha» → backend /search/parse → filtrlar.
// Natija mavjud qidiruv parametrlariga aylanadi (yangi qidiruv mexanizmi yo'q — faqat tushunish).

export const SMART_EXAMPLES = [
  '2 ta yigit talabaga Chilonzorda',
  'oilaga 3 xonali kvartira 6 mln gacha',
  'talaba qizlarga 2 kishilik uy',
  'Yunusobodda arzon kvartira',
];

/** Matn → { result, kind, params } (params — URL qidiruv parametrlari, ListingsKit filtersFromQuery tushunadi) */
export async function parseSmart(text, kindHint = 'RENT') {
  const res = await api.parseQuery(text);
  const r = res?.element;
  if (!r) return null;
  const kind = r.kind || kindHint;
  const p = new URLSearchParams();
  const put = (k, v) => { if (v != null && v !== '' && !(Array.isArray(v) && !v.length)) p.set(k, Array.isArray(v) ? v.join(',') : String(v)); };
  put('region', r.region);
  put('district', r.district);
  put('roomCount', r.roomCount);
  put('minRoomCount', r.minRoomCount);
  put('accommodationType', r.accommodationType);
  put('minPrice', r.minPrice);
  put('maxPrice', r.maxPrice);
  put('metro', r.metro);
  put('tenant', r.tenant);
  // Necha kishi: filtr 1..4 (4 = 4+)
  put('people', r.people ? Math.min(r.people, 4) : null);
  if (r.availableNow) put('availableNow', 'true');
  if (r.sort) put('sort', r.sort);
  put('q', text.trim());
  return { result: r, kind, params: p };
}

export const pathFor = (kind) => (kind === 'PARTNER' ? '/allpatneradvertising' : '/allrentadvertising');

const TENANT = { FAMILY: 'Oilaga', STUDENT: 'Talabalarga', STUDENT_MALE: 'Talaba yigitlarga', STUDENT_FEMALE: 'Talaba qizlarga' };
const fmt = (n) => Number(n).toLocaleString('ru-RU');

/** «Tushunildi: Talaba yigitlarga · 2 kishi · Chilonzor» — foydalanuvchi qidiruv nimani tushunganini ko'radi */
export function SmartChips({ result }) {
  const { t } = useTranslation();
  if (!result) return null;
  const chips = [
    result.kind === 'PARTNER' && t('Xonadosh'),
    result.tenant && t(TENANT[result.tenant]),
    result.people && t('{{n}} kishi', { n: result.people }),
    result.roomCount && t('{{n}} xonali', { n: result.roomCount }),
    result.minRoomCount && t('{{n}}+ xonali', { n: result.minRoomCount }),
    result.accommodationType && t(result.accommodationType === 'YARD' ? 'Hovli' : 'Kvartira'),
    ...(result.district || []),
    result.district?.length ? null : result.region,
    result.metro && `M ${result.metroName || result.metro}`,
    result.minPrice && t("{{n}} so'mdan", { n: fmt(result.minPrice) }),
    result.maxPrice && t("{{n}} so'mgacha", { n: fmt(result.maxPrice) }),
    result.availableNow && t("Hozir bo'sh"),
    result.sort === 'cheap' && t('Arzonlari'),
  ].filter(Boolean);
  if (!chips.length && !result.unknown?.length) return null;
  return (
    <div className='sm-chips' aria-live='polite'>
      {chips.length > 0 && <span className='sm-lbl'>{t('Tushunildi:')}</span>}
      {chips.map(c => <span key={c} className='sm-chip'>{c}</span>)}
      {result.unknown?.length > 0 && (
        <span className='sm-unknown'>{t('«{{w}}» bo\'yicha filtr yo\'q — e\'tiborga olinmadi', { w: result.unknown.join(', ') })}</span>
      )}
    </div>
  );
}

/** Matnli maydon (forma ichida ishlatiladi — submit'ni ota forma boshqaradi) */
export function SmartInput({ value, onChange, autoFocus, compact, examples = SMART_EXAMPLES }) {
  const { t } = useTranslation();
  const [ph, setPh] = React.useState(0);
  // Misollar navbatma-navbat ko'rsatiladi — nima yozish mumkinligi tushunarli bo'lsin
  React.useEffect(() => { const h = setInterval(() => setPh(i => (i + 1) % examples.length), 3500); return () => clearInterval(h); }, [examples.length]);
  return (
    <label className={`sm-input${compact ? ' compact' : ''}`}>
      <svg viewBox='0 0 24 24' width='20' height='20' fill='none' stroke='currentColor' strokeWidth='2' aria-hidden='true'><circle cx='11' cy='11' r='7' /><path d='m20 20-3.5-3.5' /></svg>
      <input type='search' aria-label={t("Qidiruv so'zlari")} value={value} onChange={e => onChange(e.target.value)} autoFocus={autoFocus} maxLength={200}
        enterKeyHint='search' placeholder={`${t('Masalan:')} ${t(examples[ph % examples.length])}`} />
    </label>
  );
}
